const storeName = 'ORDERS';
export default {
    SET_LOADING: `${storeName}.SET_LOADING`,
    LOAD_ORDERS_DATA: `${storeName}.LOAD_ORDERS_DATA`,
    SET_ORDERS_DATA: `${storeName}.SET_ORDERS_DATA`,
    SET_OFFLINE_ORDERS_DATA: `${storeName}.SET_OFFLINE_ORDERS_DATA`,
    SET_OFFLINE_API_ERROR: `${storeName}.SET_OFFLINE_API_ERROR`,
    ADD_ORDERS_DATA: `${storeName}.ADD_ORDERS_DATA`,
    GET_PAGE: `${storeName}.GET_PAGE`,
    ADD_ONE_MORE_PAGE: `${storeName}.ADD_ONE_MORE_PAGE`,
    SET_PAGE_SIZE: `${storeName}.SET_PAGE_SIZE`,
    SET_CODE: `${storeName}.SET_CODE`,
    GET_ORDERS: `${storeName}.GET_ORDERS`,
    GET_ORDER: `${storeName}.GET_ORDER`,
    SET_CURRENT_PAGE: `${storeName}.SET_CURRENT_PAGE`,
    SET_ORDERS_FOR_EXT_SERVICE: `${storeName}.SET_ORDERS_FOR_EXT_SERVICE`,
    SET_ORDER_DETAIL_FOR_EXT_SERVICE: `${storeName}.SET_ORDER_DETAIL_FOR_EXT_SERVICE`,
    ADD_ONE_MORE_PAGE_OFFLINE: `${storeName}.ADD_ONE_MORE_PAGE_OFFLINE`,
};
